import PropTypes from "prop-types"
import React, { useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Sidebar from "./Sidebar"
import AppBarHeader from "components/Layout/AppBarHeader"
import TopAdviceBar from "components/Layout/TopAdviceBar"
import { ADVICE_BAR_HEIGHT } from "components/Layout/TopAdviceBar"
import AuthContext from "context/auth/authContext"
import SubscriptionContext from "context/subscription/subscriptionContext"
import { Box } from "@mui/material"
import { getLayoutConfig } from "./layoutConfig"

const Layout = props => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { user, getUser } = useContext(AuthContext)
  const { showTopAdviceBar, isTrial, noSubscription, subscriptionState } =
    useContext(SubscriptionContext)

  useEffect(() => {
    if (!user) {
      getUser()
    }
  }, [])

  const showAdviceBar =
    user && subscriptionState && (isTrial || noSubscription) && showTopAdviceBar
  const topBarOffset = showAdviceBar ? ADVICE_BAR_HEIGHT : 0
  const { showSidebar, contentLeftOffset } = getLayoutConfig(location.pathname)

  return (
    <>
      {showSidebar ? <Sidebar /> : null}
      {showAdviceBar ? <TopAdviceBar leftOffset={contentLeftOffset} /> : null}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: `calc(100vh - ${topBarOffset}px)`,
          paddingTop: `${topBarOffset}px`,
        }}
      >
        <AppBarHeader leftOffset={contentLeftOffset} />

        <Box
          sx={{
            marginLeft: `${contentLeftOffset}px`,
            overflow: "auto",
            backgroundColor: "#f6f7fb",
            padding: "32px 16px 16px",
            flex: 1,
            minHeight: 0,
          }}
        >
          {props.children}
        </Box>
      </Box>
    </>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default Layout
